import React from 'react';
import { SxProps } from '@mui/material';
import { SelectField, TextField, useRecordContext } from 'react-admin';
import { Rule } from '../../../utilities/schemas/rules';
import { ruleNameChoices } from '../ruleFeatures';

const RuleReferenceName = ({
  sx,
}: {
  sx?: SxProps;
}) => {
  const rule = useRecordContext<Rule>();

  if (!rule) return null;

  return rule.customName ? (
    <TextField sx={sx} source="customName" />
  ) : (
    <SelectField sx={sx} source="name" choices={ruleNameChoices} />
  );
};

export default RuleReferenceName;
